import { render, staticRenderFns } from "./VSuggestWmsCustomer.vue?vue&type=template&id=74f65831"
import script from "./VSuggestWmsCustomer.vue?vue&type=script&lang=js"
export * from "./VSuggestWmsCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports